// The idempotency key of a gift purchase (POST /api/chat/gift).
//
// The backend records a gift under this key and answers a repeat with
// {"status": "duplicate"} and no charge (chat2_bp.py). The key used to be made
// from Date.now() on every attempt, so a retry after a dropped connection,
// whose first attempt had in fact been charged, was charged again (S19,
// 6 October 2026).
//
// One key per purchase intent: kept while the same gift for the same
// character is tried again, made afresh when another gift (or character) is
// chosen. The caller forgets the intent after a success, because a second gift
// of the same kind is a new purchase, not a retry.
export function purchaseIntent(
  previous,
  characterId,
  giftId,
  now = Date.now(),
) {
  if (
    previous &&
    previous.characterId === characterId &&
    previous.giftId === giftId
  ) {
    return previous
  }
  return { characterId, giftId, key: `${characterId}-${giftId}-${now}` }
}
